import { ChangeDetectionStrategy, Component, ElementRef, input } from '@angular/core';
import { Observable } from 'rxjs';

import { CompanyService } from '@app/shared/services/company.service';
import { IFBCompany } from '@interfaces';

@Component({
  selector: 'app-company-logo',
  templateUrl: './company-logo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CompanyLogoComponent {
  displayFallbackLogo = input(true);
  width = input<number | undefined>(undefined);
  height = input<number | undefined>(undefined);

  company$: Observable<IFBCompany> = this.companyService.data$;
  parentClasses = this.elRef.nativeElement.className;

  constructor(
    private companyService: CompanyService,
    private elRef: ElementRef<HTMLImageElement>
  ) {}
}
